import { PopulationQualifierKind } from "@redotech/redo-billing-common/checkout-optimization-qualifier";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const leafQualifiersSchema = z.object({
  checkoutTreeNodeId: z.string(),
  checkoutExperienceId: z.string(),
  qualifiers: z.array(
    z.object({
      kind: z.enum(PopulationQualifierKind),
      attestationId: z.string().optional(),
      splitId: z.string().optional(),
    }),
  ),
  chargedKind: z.enum(PopulationQualifierKind).optional(),
  chargedCents: z.number().optional(),
});

/**
 * Which leaves of a checkout tree earn optimization billing, and for what.
 * Null `leaves` means the team is not on qualifier billing — render nothing.
 */
export const getCheckoutTreeQualifiers = {
  name: "getCheckoutTreeQualifiers" as const,
  input: z.object({ checkoutTreeId: zExt.objectId().optional() }),
  output: z.object({ leaves: z.array(leafQualifiersSchema).nullable() }),
};
